module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"yourCurrentStep":"Your current step"}}}')
  delete Component.options._Ctor
}
